import { useQuery } from '@tanstack/react-query';
import { fetchUserPermissions } from '../services/userRbac';
import { userKeys } from './useUsersQuery';
import type { PermissionProvenance } from '../types/users.types';

export const useUserPermissionsQuery = (id: string) => {
    return useQuery<PermissionProvenance>({
        queryKey: userKeys.permissions(id),
        queryFn: () => fetchUserPermissions(id),
        enabled: !!id,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
    });
};
